import { CSSProperties, FC } from 'react';
import { Col, Row } from 'reactstrap';
import { clx } from 'Utils';
import { LoadingMask, SkeletonWrapper } from 'Elements';
import styles from 'partials/card/list-job-card.module.scss';

type Props = {
	count?: string | number;
};

const Skeleton = ({ style }: { style: CSSProperties }) => {
	return (
		<article className={styles.card} style={style}>
			<Row>
				<Col md={4}>
					<div className={clx(styles.imageBox, 'w-100 h-100')}>
						<LoadingMask className={styles.image} />
					</div>
				</Col>
				<Col md={8} className="d-flex flex-column">
					<div
						className={clx(
							styles.content,
							'd-flex flex-column mt-3 pt-2 mt-lg-0 mb-3 flex-grow-1'
						)}>
						<LoadingMask
							className={clx(styles.loading, 'mb-2 w-50')}
						/>
						<LoadingMask
							className={clx(styles.loading, 'mb-3 w-25')}
						/>
						<LoadingMask
							className={clx(styles.loading, 'w-100 mb-3')}
						/>
					</div>
					<div className="d-flex align-items-center">
						<LoadingMask
							className={clx(styles.loading, 'w-25 me-3')}
						/>
						<LoadingMask
							className={clx(styles.loading, 'w-25 ms-auto')}
						/>
					</div>
				</Col>
			</Row>
		</article>
	);
};

export const ListJobCardLoading: FC<Props> = ({ count = 3 }) => {
	return <SkeletonWrapper skeleton={Skeleton} count={count} />;
};
